// Package Imports
import React, { useEffect, useState } from 'react';

// Project Imports
import './auto-complete.css';
import { Form } from 'react-bootstrap';


const SuggestionsList = (props) => {
  const {
    suggestions,
    inputValue,
    onSelectSuggestion,
    displaySuggestions,
    selectedSuggestion,
    searchParam
  } = props;

  if (inputValue && displaySuggestions) {
    if (suggestions.length > 0) {
      return (
        <ul className="suggestions-list pointer">
          {suggestions.map((suggestion, index) => {
            const isSelected = selectedSuggestion === index;
            const classname = `suggestion ${isSelected ? 'selected' : ''
              }`;
            return (
              <li
                key={index}
                className={`${classname} font-size-14  font-size-lg-12 `}
                onClick={() => onSelectSuggestion(index)}
              >
                <p className='m-2 text-state'>
                  <span className="font-bold">{suggestion[searchParam]}</span>
                </p>
              </li>
            );
          })}
        </ul>
      );
    } else {
      return <div className="text-danger font-size-14 font-size-lg-12 error-message">No data available</div>;
    }
  }
  return <div></div>;
};
export default function Autocomplete(props) {
  const {
    placeholder,
    suggestions,
    searchParam,
    onOptionSelectChange,
    name,
    disabled,
    onAutocompleteTextChange
  } = props;
  const [inputValue, setInputValue] = useState(
    props.value ? props.value[searchParam] : ''
  );
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState(0);
  const [displaySuggestions, setDisplaySuggestions] = useState(false);

  const onChange = (event) => {

    const value = event.target.value;
    setInputValue(value);
    if (value.length > 2) {
      const filteredSuggestions = suggestions.filter((suggestion) =>
        suggestion[searchParam]?.toLowerCase().includes(value?.toLowerCase())
      );
      setFilteredSuggestions(filteredSuggestions);
      setDisplaySuggestions(true);
      onAutocompleteTextChange(name, value);
    }
  };

  useEffect(() => {
    if (props.value && props.value !== undefined) {
      setInputValue(props.value[searchParam]);
    }
  }, [props.value]);

  const onSelectSuggestion = (index) => {
    let selectedOption = filteredSuggestions[index][searchParam];
    setSelectedSuggestion(index);
    setInputValue(selectedOption);
    setFilteredSuggestions([]);
    setDisplaySuggestions(false);
    onOptionSelectChange(filteredSuggestions[index], name);
  };

  return (
    <div>
      <Form.Group className='mb-0 flex-grow-1'>
        <Form.Control
          className='font-size-lg-12 font-size-14 font-weight-light'
          placeholder={placeholder}
          disabled={disabled}
          value={inputValue}
          onChange={onChange}
        />
      </Form.Group>
      {/* <input
        placeholder={placeholder}
        className="user-input w-100"
        type="text"
        disabled={disabled}
        onChange={onChange}
        value={inputValue}
      /> */}
      <SuggestionsList
        inputValue={inputValue}
        selectedSuggestion={selectedSuggestion}
        onSelectSuggestion={onSelectSuggestion}
        displaySuggestions={displaySuggestions}
        suggestions={filteredSuggestions}
        searchParam={searchParam}
      />
    </div>
  );
}